module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "h4"
    }
  }, [_vm._v("Acknowledgements")])]), _c('a', {
    attrs: {
      "id": "h4"
    }
  }, [_c('p', {
    staticClass: "common"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Quotations from the Royal Archives appear by gracious permission of Her Majesty the Queen. Quotations from Crown copyright material in The National Archives appear by permission of Her Majesty’s Stationery Office. The editors and authors also give their thanks to the following for allowing them to consult and quote from archives in their possession and/or copyright: The Trustees of the Liddell Hart Centre for Military Archives, King’s College, London; The Trustees of the British Library Board; The Trustees of the Imperial War Museum; The National Army Museum; The Royal Pavilion Libraries and Museums (Hove Reference Library); The National Library of Scotland; The Sudan Archive of the University of Durham; The Killie Campbell Library of the University of KwaZulu-Natal; The KwaZulu-Natal Archives; South Lanarkshire Council Museum; and The William Perkins Library of the University of Durham, North Carolina.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d31ace6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_acknowledgements.vue
// module id = 75
// module chunks = 0